export default __webpack_public_path__ + "79e148b540ad26273d8db59237a938cd.svg";